import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import * as versionJson from "../../version.json";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { providers } from "@app/di/providers";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateLoader,
  TranslateModule,
} from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { ToastServiceModule } from "@app/presentation/services/toast.service";
import { DialogModule } from "@angular/cdk/dialog";
import { PushNotificationsModule } from "@app2u/notifications";
import localeEs from "@angular/common/locales/es";
import localeCa from "@angular/common/locales/ca";
import localeEn from "@angular/common/locales/en";
import localeFr from "@angular/common/locales/fr";
import localeDe from "@angular/common/locales/de";
import localeIt from "@angular/common/locales/it";
import localePt from "@angular/common/locales/pt";
import localeNl from "@angular/common/locales/nl";
import localeRu from "@angular/common/locales/ru";
import localeHe from "@angular/common/locales/he";

import { registerLocaleData } from "@angular/common";

function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    "./assets/i18n/",
    `.json?v=${versionJson.build}`
  );
}
/*For date pipe to translate dates*/
registerLocaleData(localeEs);
registerLocaleData(localeCa);
registerLocaleData(localeEn);
registerLocaleData(localeFr);
registerLocaleData(localeDe);
registerLocaleData(localeIt);
registerLocaleData(localePt);
registerLocaleData(localeNl);
registerLocaleData(localeRu);
registerLocaleData(localeHe);

/**
 * This handler is used to provide a fallback value when a translation is missing.
 */
class MissingTranslationHandlerWithFallback
  implements MissingTranslationHandler
{
  handle(params: MissingTranslationHandlerParams) {
    //console.warn('MISSING ' + params.translateService.currentLang + ' TRANSLATION: ' + params.key )
    if (params.interpolateParams != null) {
      //If the translation is missing, we return the fallback value if it exists.
      //console.warn('MISSING ' + params.translateService.currentLang + ' TRANSLATION: ' + params.key )
      return (params.interpolateParams as any).fallback ?? params.key;
    }
    return params.key;
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      defaultLanguage: "en",
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MissingTranslationHandlerWithFallback,
      },
    }),
    AngularSvgIconModule.forRoot(),
    ToastServiceModule,
    DialogModule,
    PushNotificationsModule,
  ],
  providers: [...providers],
  exports: [DialogModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
